import Button from "./Button";
import SkillList from "./SkillList";
import SocialIcons from "./SocialIcons";

const Main = () => {
  return (
    <div className="h-[80vh] w-full grid content-center p-4">
      <div className="flex flex-col items-center justify-center h-full text-center sm:items-start sm:text-left">
        <h2 className="font-light tracking-widest dark:text-highlight text-l">
          Hi, my name is
        </h2>
        <h1 className="mb-4 text-3xl text-gray-800 sm:text-4xl md:text-5xl xl:text-6xl dark:text-textHeading">
          William, <br className="hidden sm:block" /> I'm a{" "}
          <br className="sm:hidden" />
          <span className="text-gray-900 underline dark:text-highlight">
            Front-End Developer
          </span>
          <span className="animate-pulse">.</span>
        </h1>
        <h6 className="dark:text-text text-sm md:text-base md:max-w-[630px] max-w-[450px] font-normal font-secondary mb-8 tracking-wider text-gray-800">
          I'm a self-taught Front-End Developer specializing in building (and
          occasionally designing) user interfaces using modern front-end web
          technologies.
        </h6>

        <SkillList />

        <Button text="See My Work" navigate="projects" />

        <SocialIcons />
      </div>
    </div>
  );
};

export default Main;
